export const compileEditPostData = (editorState) => {

    const { immutableBaseData, mutableBaseData, mutableEditing } = editorState;

    const { rowKeys } = immutableBaseData;
    const { rows: rowsData } = mutableBaseData;
    const { addedRows, editedRows, deletedRowKeys } = mutableEditing;

    // deletedRows contains preexisting and new row keys that we need to separate
    const deletedPreexistingRowKeys = deletedRowKeys.filter(rowKey => rowKeys.includes(rowKey));
    const deletedNewRowKeys = deletedRowKeys.filter(rowKey => !rowKeys.includes(rowKey));

    const addedRowsData = formatAddedRowsData(addedRows, deletedNewRowKeys);
    const editedRowsData = formatEditedRowsData(editedRows, deletedPreexistingRowKeys, rowsData);

    return {
        added: addedRowsData,
        edited: editedRowsData,
        deleted: deletedPreexistingRowKeys,
    }

};


const formatAddedRowsData = (addedRows, deletedRowKeys) => {
    /**
     * Convert the added row data from the frontend into something the backend can use.
     *
     * */

    const addedRowsData = {};

    Object.keys(addedRows).forEach(rowKey => {
        // we can ignore any rows that were deleted before saving.
        if ( !deletedRowKeys.includes(rowKey) ) {
            addedRowsData[rowKey] = addedRows[rowKey]
        }
    });

    return addedRowsData
};


const formatEditedRowsData = (editedRows, deletedRowKeys, rowsData) => {
    /**
     * Convert the edited row data from the frontend into something the backend can use.
     *
     * */

    const editedRowsData = {};

    Object.keys(editedRows).forEach(rowKey => {
        // we can ignore any rows that were deleted before saving.
        if ( !deletedRowKeys.includes(rowKey) ) {
            const rowData = rowsData[rowKey];
            if ( rowData !== undefined ) {
                editedRowsData[rowKey] = formatEditedRowData(rowData, editedRows[rowKey])
            }
        }

    });

    return editedRowsData
};

const formatEditedRowData = (rowData, editedRowData) => {
    /**
     * The edited data contains only a reference to what data was edited, so we need to retrieve the data itself.
     * */

    const formattedData = {};
    editedRowData.forEach(fieldData => {
        const fieldName = fieldData.fieldName;
        formattedData[fieldName] = rowData[fieldName];
    });

    return formattedData;
};
